var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-alpha-slider",class:{ 'is-vertical': _vm.vertical }},[_c('div',{ref:"bar",staticClass:"color-alpha-slider__bar",style:({
      background: _vm.background
    }),on:{"click":_vm.handleClick}}),_c('div',{ref:"thumb",staticClass:"color-alpha-slider__thumb",style:({
      left: _vm.thumbLeft + 'px',
      top: _vm.thumbTop + 'px'
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }